// src/core/multiplayer.js
import * as Colyseus from "colyseus.js";

const multiplayer = {
    client: null,
    room: null,
    onStateChange: null, // External callback listener

    // Yerel seçim (DOM bağımsız takip)
    localSelection: -1,

    // Sunucu adresi - Otomatik algılama
    SERVER_URL: (function () {
        const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
        const host = window.location.hostname;
        if (host === 'localhost' || host === '127.0.0.1') {
            return 'ws://localhost:2567';
        }
        return `${protocol}://${window.location.host}`;
    })(),

    // HTTP API Adresi (Colyseus 0.16 getAvailableRooms yerine kullanacağız)
    HTTP_URL: (function () {
        const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
        const host = window.location.hostname;
        if (host === 'localhost' || host === '127.0.0.1') {
            return 'http://localhost:2567';
        }
        return `${protocol}://${window.location.host}`;
    })(),

    init: function () {
        this.client = new Colyseus.Client(this.SERVER_URL);
        window.colyseusClient = this.client; // [FIX] MatchmakingManager needs global access
        console.log("Multiplayer ağı başlatıldı:", this.SERVER_URL);
    },

    createRoom: async function (roomName, playerName, options = {}) {
        try {
            // roomName: 'quiz'
            // Eğer roomName bir obje ise (eski çağrı uyumluluğu), düzelt
            if (typeof roomName === 'object') {
                options = playerName || {};
                playerName = roomName.name || "Oyuncu";
                roomName = "quiz";
            } else if (typeof playerName === 'object') {
                // createRoom("quiz", { ... }) durumu
                options = playerName;
                // [FIX] Try to get name from options, then Auth, then default
                playerName = options.name;
                if (!playerName && window.AuthManager && window.AuthManager.profile) {
                    playerName = window.AuthManager.profile.username;
                }
                if (!playerName) playerName = "Oyuncu";
            }

            console.log(`🚀 Creating Room: ${roomName} as ${playerName}`);
            console.log(`📊 Options being sent:`, options);
            console.log(`📊 maxPlayers value: ${options.maxPlayers}, parsed: ${parseInt(options.maxPlayers) || 2}`);

            this.room = await this.client.create(roomName, {
                name: playerName,
                character: options.character || "karakter1.png", // [NEW]
                category: options.category || "karisik",
                maxPlayers: parseInt(options.maxPlayers) || 2,
                music: options.music || "düştük_tımarhaneye son versiyon.mp3",
                // [NEW] Settings
                isPrivate: options.isPrivate || false,
                turnTime: options.turnTime || 20,
                lives: options.lives || 3,
                token: options.token // [AUTH FIX] Pass token for stats logic
            });
            this.setupRoomListeners();
            return this.room;
        } catch (e) {
            console.error("Oda oluşturulamadı:", e);
            throw e;
        }
    },

    joinRoom: async function (roomIdOrCode, playerName, options = {}) {
        try {
            let targetRoomId = roomIdOrCode;

            // [NEW] Resolve Room Code if needed
            // If length is small (e.g. 5-6), assume it's a code
            if (roomIdOrCode.length < 10) {
                console.log(`🔍 Room Code/ID check (${roomIdOrCode})...`);
                const allRooms = await this.getAvailableRooms();

                // [FIX] Check BOTH roomCode and roomId
                const match = allRooms.find(r =>
                    (r.metadata && r.metadata.roomCode === roomIdOrCode.toUpperCase()) ||
                    r.roomId === roomIdOrCode
                );

                if (match) {
                    console.log(`✅ Room found: ${match.roomId}`);
                    targetRoomId = match.roomId;
                } else {
                    // Try joining by ID directly if not found in list (e.g. private room not listed?)
                    // Or throw error. For now, trust the list if it's supposed to be there.
                    // But if it's a code, it MUST be in the list metadata.
                    // If it's an ID, it might work directly.
                    // Let's assume failures are mostly "Code Not Found" for users.
                    console.warn("❌ Room not found in list. Trying direct ID join as last resort...");
                }
            }

            // [FIX] Join Name Logic
            let finalName = "";
            if (typeof playerName === 'string') finalName = playerName;
            else if (options.name) finalName = options.name;

            if (!finalName && window.AuthManager && window.AuthManager.profile) {
                finalName = window.AuthManager.profile.username;
            }
            if (!finalName) finalName = "Oyuncu";

            console.log(`🚀 Joining Room: ${targetRoomId} as ${finalName}`);

            const joinOptions = { name: finalName, ...options };
            this.room = await this.client.joinById(targetRoomId, joinOptions);
            this.setupRoomListeners();
            return this.room;
        } catch (e) {
            console.error("Odaya girilemedi:", e);
            throw e;
        }
    },

    leaveRoom: function () {
        if (this.room) {
            this.room.leave();
            this.room = null;
            // [FIX] Destroy Chat Manager to remove UI
            if (window.ChatManager) {
                window.ChatManager.destroy();
            }
            console.log("Odadan ayrılındı.");
        }
    },

    getAvailableRooms: async function () {
        try {
            console.log("🔍 Odalar taranıyor...");
            const fetchRoomType = async (type) => {
                try {
                    const response = await fetch(`${this.HTTP_URL}/api/proxy/rooms/${type}`);
                    if (!response.ok) {
                        console.warn(`⚠️ ${type} odaları alınamadı: HTTP ${response.status}`);
                        return [];
                    }
                    const data = await response.json();
                    console.log(`✅ ${type} türünde ${data.length} oda bulundu.`);
                    return data;
                } catch (err) {
                    console.error(`❌ ${type} fetch hatası:`, err.message);
                    return [];
                }
            };

            // Bağımsız ve paralel sorgu (biri çökerse diğeri çalışmaya devam eder)
            // Bağımsız ve paralel sorgu (biri çökerse diğeri çalışmaya devam eder)
            const [quizRooms] = await Promise.all([
                fetchRoomType("quiz")
            ]);

            const allRooms = [...quizRooms];
            console.log(`📊 Toplam ${allRooms.length} oda keşfedildi.`);
            return allRooms;
        } catch (e) {
            console.error("Available rooms fetch error (HTTP API):", e);
            return [];
        }
    },

    setupRoomListeners: function () {
        console.log("Room Connected:", this.room.id);

        // State değişimlerini dinle ve dışarı aktar
        this.room.onStateChange((state) => {
            if (this.onStateChange) {
                this.onStateChange(state);
            }
        });

        // Bağlantı kopma/ayrılma dinleyicisi
        this.room.onLeave((code) => {
            console.log("Bağlantı kesildi. Kod:", code);
            if (this.onDisconnected) {
                this.onDisconnected(code);
            }
        });
    },

    startGame: function () {
        if (this.room) {
            this.room.send("start");
        }
    },

    sendAnswer: function (index) {
        if (this.localSelection !== -1) return; // Zaten cevap verildi
        this.localSelection = index;
        if (this.room) {
            this.room.send("answer", index);
        }
    },

    // Yeni soru geldiğinde çağrılmalı
    resetLocalState: function () {
        this.localSelection = -1;
    }
};

// Global'e ekle
window.multiplayer = multiplayer;
// [REMOVED] Auto-init moved to main.js
// multiplayer.init();
